export default __webpack_public_path__ + "static/stacked-bar-016a0826ca2d35f8d2c35c211956517b.png";